module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "italic-weiss"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAGMENT:")]), _vm._v(" A R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMINDER")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In the beginning, we were as one. ")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But God felt we couldn’t satisfy him like that, so God set about dividing us. God had great fun with us, then God tired of us and forgot us. God could be so cruel in his indifference, he horrified me. God knew how to show his gentle side, too, and I loved him as I’ve loved no one else.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I think we could have all lived happily, in a way, God, me, and the others, if it weren’t for that accursed book. It disgusted me. I knew what bound me to it in the most sickening of ways, but the horror of that particular knowledge came later, much later. I didn’t understand straightaway, I was too ignorant.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I loved God, yes, but I despised that book, which he’d open at the drop of a hat. As for God, he relished it. When God was happy, he wrote. When God was furious, he wrote. And one day, when God was in a really bad mood, he did something enormously stupid.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("God smashed the world to pieces.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s coming back to me—God was punished. On that day, I understood that God wasn’t all-powerful. Since then, I’ve never seen him again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25006da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EE_DABOS_CLAIRDELUNE_ebk_00006.vue
// module id = 84
// module chunks = 0